import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

window.addEventListener('DOMContentLoaded', () => {
    Swiper.use([Pagination]);

    const cardSliderContainers = document.querySelectorAll(
        '.swiper-container.card-slider'
    );

    cardSliderContainers.forEach((cardSliderContainer) => {
        const swiperID = cardSliderContainer.parentElement.getAttribute('data-swiperid');

        const slideCount = cardSliderContainer.querySelectorAll('.swiper-slide').length;

        new Swiper(cardSliderContainer, {
            modules: [Pagination],
            spaceBetween: 16,
            slidesPerView: 1,
            watchOverflow: true,
            centerInsufficientSlides: true,
            pagination: {
                el: `[data-swiperid="${swiperID}"] .swiper-pagination`,
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: slideCount <= 2 ? slideCount : 2,
                },
                1024: {
                    slidesPerView: slideCount <= 3 ? slideCount : 3,
                },
                1366: {
                    slidesPerView: slideCount <= 4 ? slideCount : 4,
                    spaceBetween: 0,
                },
            },
        });
    });
});
